// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /chat-invitation/list.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeChatInvitationListBody,
  typeChatInvitationListOutput200,
} from "../../sdk/chatInvitation/postChatInvitationList";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildChatInvitationListQueryKey(
  payload: typeChatInvitationListBody,
): string[] {
  const queryKeySegments: string[] = [];
  if (typeof payload.cursor !== "undefined") {
    queryKeySegments.push(`cursor:${JSON.stringify(payload.cursor)}`);
  }
  return [
    "post:chatInvitation:chatInvitationList",
    "svc:messaging-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeChatInvitationListOutput200,
    unknown,
    typeChatInvitationListOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useChatInvitationList(
  payload: typeChatInvitationListBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildChatInvitationListQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postChatInvitationList(payload),
    ...resolvedOptions,
  });
}
